export default __webpack_public_path__ + "src/assets/tx-in-block.70083207a329ed624781e001444ff91d.svg";